import { render } from "./recargasMasivas.vue?vue&type=template&id=4d04e6a1&scoped=true"
import script from "./recargasMasivas.vue?vue&type=script&lang=js"
export * from "./recargasMasivas.vue?vue&type=script&lang=js"

import "./recargasMasivas.vue?vue&type=style&index=0&id=4d04e6a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d04e6a1"]])

export default __exports__